import { render } from "./repairsDetailsModal.vue?vue&type=template&id=17a12cc4&scoped=true"
import script from "./repairsDetailsModal.vue?vue&type=script&lang=js"
export * from "./repairsDetailsModal.vue?vue&type=script&lang=js"

import "./repairsDetailsModal.vue?vue&type=style&index=0&id=17a12cc4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17a12cc4"]])

export default __exports__